import React, { useEffect } from "react";
import "./manageDeliveries.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShoppingCart,
  faBox,
  faTruck,
  faCheckCircle,
  faClockRotateLeft
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";


export default function ManageDeliveries() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const steps = [
    {
      icon: faShoppingCart,
      title: "Order Placed",
      description: "Your order has been placed and is being processed."
    },
    {
      icon: faBox,
      title: "Packed & Ready",
      description: "Items are packed securely and ready for shipment."
    },
    {
      icon: faTruck,
      title: "Out for Delivery",
      description: "Your package is on its way to your location."
    },
    {
      icon: faCheckCircle,
      title: "Delivered",
      description: "Your order has been successfully delivered."
    },
    {
      icon: faClockRotateLeft,
      title: "Return / Exchange",
      description: "Easily manage returns or exchanges within 7 days."
    }
  ];

  return (
    <>
      <Helmet>
        <title>SHOP.CO | Manage Deliveries - Track & Update Orders</title>
        <meta
          name="description"
          content="Easily manage your deliveries with SHOP.CO. Track orders, update delivery preferences, and view shipping details in one place."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/FAQ/manage-deliveries/"
        />
      </Helmet>

      <div className="manage-deliveries-container">
        <header className="manage-deliveries-header">
          <h1>Manage Your Deliveries</h1>
          <p>Track and manage every step of your delivery process smoothly.</p>
        </header>

        <div className="manage-deliveries">
          {steps.map((step, index) => (
            <div key={index} className="manage-deliveries-item">
              <div className="manage-deliveries-icon">
                <FontAwesomeIcon icon={step.icon} />
              </div>
              <div className="manage-deliveries-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
